import React, { useContext, useState } from "react";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { Banner, ConfigureButton } from "./SharedBannerStyle";
import AnalyzeBannerSVG from "../../../images/analyze_banner.svg";
import { AnalyzeLearnMoreModal } from "./AnalyzeLearnMoreModal";
import { useHistory } from "react-router-dom";
import { PATHS } from "../../../Routes";
import Parser from "html-react-parser";
import { CREATE_EVENT } from "../../../graphql/Mutations/Event";
import { useCompanyAsAdminQuery } from "../../../graphql";
import { useMutation } from "@apollo/client";
import {
    EventCategory,
    METRIC_EVENT_CATALOG,
    MetricEventKey,
} from "@grabcad/company-server-shared/dist/types";

enum CTAType {
    CONFIGURE_ANALYZE = "configure_analyze",
    LEARN_MORE = "learn_more",
}
interface AnalyzeBannerProps {
    onCTAButtonClick: () => void;
    onCancel: () => void;
    hasAnalyzeSAASFeature: boolean;
}

const AnalyzeBanner: React.FC<AnalyzeBannerProps> = ({
    onCTAButtonClick,
    onCancel,
    hasAnalyzeSAASFeature,
}) => {
    const { t } = useContext(ApplicationContext);
    const history = useHistory();

    const [showModal, setShowModal] = useState(false);
    const { company } = useCompanyAsAdminQuery();
    const [triggerCreateEvent] = useMutation(CREATE_EVENT);

    const handleCTAButtonClick = () => {
        if (!company?.internal) {
            const ctaMetricKeyMap: Record<CTAType, MetricEventKey> = {
                [CTAType.LEARN_MORE]: MetricEventKey.LEARN_MORE_CLICKED,
                [CTAType.CONFIGURE_ANALYZE]: MetricEventKey.CONFIGURE_ANALYZE_CLICKED,
            };

            const metricKey = ctaMetricKeyMap[ctaType];

            if (metricKey) {
                const { action, description } = METRIC_EVENT_CATALOG[metricKey];

                void triggerCreateEvent({
                    variables: {
                        events: [
                            {
                                event: EventCategory.GC_ANALYZE,
                                action,
                                description,
                            },
                        ],
                    },
                }).catch((err) => console.error("Failed to log event:", err));
            }
        }

        if (ctaType === CTAType.LEARN_MORE) {
            onCTAButtonClick();
            setShowModal(true);
        } else {
            history.push({
                pathname: PATHS.configureAnalyze,
            });
        }
    };

    const ctaText = hasAnalyzeSAASFeature
        ? t("homepage.analyze_feature.configure_analyze")
        : Parser(t("homepage.analyze_feature.learn_more"));

    const ctaType = hasAnalyzeSAASFeature ? CTAType.CONFIGURE_ANALYZE : CTAType.LEARN_MORE;

    return (
        <Banner background={AnalyzeBannerSVG} data-testid="analyze-banner">
            <div className="banner">
                <div className="text-section">
                    <h4>{t("homepage.analyze_feature.analyze_sass_new")}</h4>
                    <h1>{t("homepage.analyze_feature.analyze_sass_avaialble")}</h1>
                </div>
                <ConfigureButton
                    style={{ color: "white" }}
                    onClick={handleCTAButtonClick}
                    data-testid="cta-button"
                >
                    {ctaText}
                </ConfigureButton>
            </div>
            {showModal && (
                <AnalyzeLearnMoreModal
                    open={showModal}
                    setOpen={setShowModal}
                    onCancel={onCancel}
                />
            )}
        </Banner>
    );
};

export default AnalyzeBanner;
